// src/contexts/ThemeContext.jsx 

import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  // Forçamos o estado inicial sempre como 'light'
  const [theme] = useState("light");

  // Mantemos a função toggleTheme para não quebrar componentes que a chamam,
  // mas ela não fará nenhuma alteração de estado.
  const toggleTheme = () => {
    console.log("O sistema está configurado apenas para o Modo Claro.");
  };

  useEffect(() => {
    // Garante que o HTML sempre tenha o atributo light e remova classes dark
    document.documentElement.setAttribute("data-theme", "light");
    document.documentElement.classList.remove("dark");
    
    // Limpamos o localStorage para evitar conflitos futuros
    localStorage.setItem("theme", "light");
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);